import { BookingCreatePage } from "@/features/private-room/bookings/layouts/booking-create-page";

export const BookingCreate = () => {
  return <BookingCreatePage />;
};
